import './smallDivider.css';

const SmallDivider = () => {
	return <div className='small-divider'></div>;
};
export default SmallDivider;
